import webApi from './WebApi';
export function randomString(length = 16) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let output = '';
    if (length < 0) {
        return output;
    }
    const randomValues = new Uint32Array(length);
    webApi.crypto?.getRandomValues(randomValues);
    randomValues.forEach((value) => {
        output += characters.charAt(value % charactersLength);
    });
    return output;
}
//# sourceMappingURL=utils.js.map